import { Context, ContextMembership } from './context.data'
import { firestoreTimestampToDate, isDate } from "../utils/obejct-diff"
import { NetworkConstants } from './network.constants'

export class Trophy {

    public context: Context|ContextMembership|undefined = undefined
    
    public identifier: string|undefined = undefined
    public contextId: string|undefined = undefined
    public gameRecordId: string|undefined = undefined
    public huntingDistrictId: string|undefined = undefined
    public huntingDistrictName: string|undefined = undefined
    public tagID: string|undefined = undefined
    public type: string|undefined = undefined
    public typeTitle: string|undefined = undefined
    public comment: string|undefined = undefined
    public creationDate: Date|undefined = undefined
    public updateTimestamp: Date|undefined = undefined
    

    constructor(
        context?: Context|ContextMembership
    ) {
        this.context = context
    }

    setFromAny(element: any) {
        const {
            identifier, 
            contextId, 
            gameRecordId,
            huntingDistrictId, 
            huntingDistrictName,
            tagID,
            type,
            comment,
            typeTitle,
            creationDate, 
            updateTimestamp
        } = element
        if (!typeTitle && this.type) this.typeTitle = this.getTypeTitle()
        this.identifier = identifier ? identifier : this.identifier
        this.contextId = contextId ? contextId : this.contextId
        this.gameRecordId = gameRecordId ? gameRecordId : this.gameRecordId
        this.huntingDistrictId = huntingDistrictId ? huntingDistrictId : this.huntingDistrictId
        this.tagID = tagID ? tagID : this.tagID
        this.type = type ? type : this.type
        this.comment = comment ? comment : this.comment
        this.creationDate = creationDate ? isDate(creationDate) ? creationDate : firestoreTimestampToDate(creationDate) : this.creationDate
        this.updateTimestamp = updateTimestamp ? isDate(updateTimestamp) ? updateTimestamp : firestoreTimestampToDate(updateTimestamp) : this.updateTimestamp
        this.typeTitle = typeTitle ? typeTitle : this.typeTitle
        this.huntingDistrictName = huntingDistrictName ? huntingDistrictName : this.huntingDistrictName
    }

    getTypeTitle() {
        if (this.typeTitle) return this.typeTitle
        if (!this.type) return undefined
        const settingRef = NetworkConstants.SETTING_TROPY_TYPE
        const setting = this.context?.settingsMap.get(settingRef)
        if (!this.context || !setting) return this.type ? this.type : undefined
        const quality = setting.values.find(el => el.identifier == this.type)
        if (!quality) return this.type ? this.type : undefined
        return quality.title ? quality.title : this.type ? this.type : undefined
    }

    searchFilter(filter: string): boolean {
        const str = `${this.type}${this.typeTitle}${this.tagID}`.toLowerCase()
        return str.includes(filter)
    }

    /**
     * Function for skipping objects and data while deepcopying class.
     * used as optional Input for deepCopy(any, replacerFn)
     * @param key 
     */
    replacerFn(key: string) {
        const list = ["context"]
        if (list.includes(key)) return false
        else return true
    }
}